var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-secondary btn-sm me-1",attrs:{"type":"button","disabled":!_vm.canDelete},on:{"click":_vm.remove}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])
}
var staticRenderFns = []

export { render, staticRenderFns }